import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlayIcon, PauseIcon, TrashIcon } from "../../../../icons";
// Status badge styling
const getStatusBadge = (status) => {
    switch (status) {
        case 'building':
            return {
                text: 'Generating...',
                className: 'bg-gray-100 border-purple-sparkle-soft text-primary-purple-70 font-bold',
                isGradient: true,
            };
        case 'initializing':
            return {
                text: 'Initializing...',
                className: 'bg-gray-100 border-gray-300 text-gray-900 font-bold',
                isGradient: false,
            };
        case 'queued':
            return {
                text: 'Queued',
                className: 'bg-gray-100 border-gray-300 text-gray-700 font-bold',
                isGradient: false,
            };
        case 'paused':
            return {
                text: 'Paused',
                className: 'bg-yellow-50 border-yellow-300 text-yellow-800 font-bold',
                isGradient: false,
            };
        case 'failed':
            return {
                text: 'Failed',
                className: 'bg-red-50 border-red-300 text-red-800 font-bold',
                isGradient: false,
            };
        default:
            return {
                text: status,
                className: 'bg-gray-100 border-gray-300 text-gray-700',
                isGradient: false,
            };
    }
};
export const BuildProgressRow = ({ job, isActive = false, onPause, onResume, onCancel, onClick, }) => {
    const statusBadge = getStatusBadge(job.status);
    const isRunning = job.status === 'building';
    const isQueued = job.status === 'queued' || job.status === 'initializing';
    const isPaused = job.status === 'paused';
    const handleClick = (e) => {
        // Don't trigger click if clicking on buttons
        if (e.target.closest('button'))
            return;
        onClick?.(job.planId);
    };
    const handlePauseResume = (e) => {
        e.stopPropagation();
        if (isRunning) {
            onPause?.(job.planId);
        }
        else if (isPaused || isQueued) {
            onResume?.(job.planId);
        }
    };
    const handleCancel = (e) => {
        e.stopPropagation();
        onCancel?.(job.planId);
    };
    return (_jsxs("div", { onClick: handleClick, className: `
                relative flex items-center gap-2 px-3 py-4 rounded-lg border transition-colors cursor-pointer
                ${isActive
            ? 'bg-gray-100 border-purple-sparkle-soft'
            : isRunning
                ? 'bg-gray-100 border-gray-300 hover:bg-gray-50'
                : 'bg-gray-100 border-gray-200 hover:bg-gray-50'}
            `, children: [_jsxs("div", { className: "flex-1 flex flex-col items-start", children: [_jsxs("div", { className: "flex items-center gap-2 w-full", children: [_jsx("div", { className: `
                        flex items-center gap-1 px-2 py-0.5 rounded-full border text-[13px]
                        ${statusBadge.className}
                    `, children: statusBadge.isGradient ? (_jsx("span", { className: "bg-clip-text", style: {
                                        WebkitTextFillColor: 'transparent',
                                        backgroundImage: 'linear-gradient(156deg, rgba(157, 113, 255, 0.4) 0%, rgba(75, 120, 236, 0.4) 100%), linear-gradient(90deg, #3b28cc 0%, #3b28cc 100%)',
                                    }, children: statusBadge.text })) : (_jsx("span", { children: statusBadge.text })) }), _jsxs("div", { className: "flex items-center gap-0.5 px-1 py-px rounded border border-gray-300 bg-gray-100 text-[12px] text-gray-900", children: [job.slideCount, " slides"] }), _jsx("p", { className: "flex-1 text-[13px] text-gray-990 truncate", children: job.planTitle })] }), isRunning && job.currentActivity && (_jsxs("p", { className: "text-[11px] text-gray-500 mt-1 truncate", children: [job.currentSection && `${job.currentSection}: `, job.currentActivity] }))] }), _jsxs("div", { className: "flex items-center gap-2", children: [(isRunning || isPaused || isQueued) && (_jsx("button", { onClick: handlePauseResume, className: "p-1.5 rounded-lg hover:bg-gray-200 transition-colors", title: isRunning ? 'Pause' : 'Resume', children: isRunning ? (_jsx(PauseIcon, { size: 16, color: "#374151" })) : (_jsx(PlayIcon, { size: 16, color: "#374151" })) })), _jsx("button", { onClick: handleCancel, className: "p-1.5 rounded-lg hover:bg-gray-200 transition-colors", title: "Cancel", children: _jsx(TrashIcon, { size: 16, color: "#374151" }) })] }), isRunning && (_jsx("div", { className: "absolute bottom-0 left-[-1px] h-[2px] bg-primary-purple-60 rounded-full transition-all duration-300", style: { width: `${Math.min(job.progress, 100)}%` } }))] }));
};
export default BuildProgressRow;
